import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { PRIMARY } from "../../constants";

export function SectionHeader({ title, icon: Icon }) {
  return (
    <Stack
      direction="row"
      spacing={1.25}
      alignItems="center"
      sx={{ mb: { xs: 3, sm: 3.5 }, textAlign: "left" }}
    >
      {Icon ? (
        <Box sx={{ color: PRIMARY, display: "flex", alignItems: "center", flexShrink: 0 }}>
          <Icon sx={{ fontSize: 22 }} />
        </Box>
      ) : null}
      <Typography
        sx={{
          fontFamily: "Rubik, sans-serif",
          fontWeight: 700,
          fontSize: "1.05rem",
          color: PRIMARY,
          letterSpacing: "0.01em",
        }}
      >
        {title}
      </Typography>
    </Stack>
  );
}
